import immutableStore from 'utils/immutableStore';
import {Map, Record} from 'immutable';
import alt from 'components/Dispatcher';
import PastPlanActions from 'actions/coaching/PastPlanActions';

@immutableStore
class PastPlanStore {
  constructor() {
    this.state = Record({
      pastPlansLoading: false,
      pastPlansError: false,
      pastPlans: Map(),
    })();
    this.bindActions(PastPlanActions);
  }

  getPastPlans() {
    this.setState({
      pastPlansLoading: true,
      pastPlansError: false,
      pastPlans: Map(),
    });
  }

  getPastPlansSuccess(plans) {
    this.setState({
      pastPlansLoading: false,
      pastPlansError: false,
      pastPlans: plans,
    });
  }

  getPastPlansError(err) {
    this.setState({
      pastPlansLoading: false,
      pastPlansError: true,
      pastPlans: Map(),
    });
  }
}

export default alt.createStore(PastPlanStore, 'PastPlanStore');
